// Generally, everything is pointing to production,
// unless we are running the API locally.

export const IS_PROD = process.env.NODE_ENV === 'production';
export const IS_STAGING =
  typeof window !== 'undefined' &&
  window.location.hostname === 'funbrain-staging.herokuapp.com';
const LOCAL_API = process.env.LOCAL_API;
export const LOCAL_CONTENT = process.env.LOCAL_CONTENT;

const SCHEME = IS_PROD ? 'https://' : 'http://';
const CONTENT_PROD_SERVER_HOST = 'www.funbrain.com';
const API_PROD_SERVER_URL = 'https://www.funbrain.com/api';
const API_LOCAL_SERVER_URL = 'http://127.0.0.1:5000';
const ASSETS_PROD_URL = 'https://www.funbrain.com/assets';
const ASSETS_STAGING_URL = 'https://www.funbrain.com/staging/assets';

export const SITE_HOST = IS_PROD
  ? `funbrain-html.herokuapp.com`
  : `localhost:8080`;
export const SITE_URL = `${SCHEME}${SITE_HOST}`;
export const CANONICAL_URL = `https://www.funbrain.com`;
export const ASSETS_URL =
  process.env.ASSETS_ENV === 'production'
    ? ASSETS_PROD_URL
    : ASSETS_STAGING_URL;
export const AD_TRACK_URL = 'https://www.funbrain.com/brain/track.php';

export const API_URL = LOCAL_API
  ? `${API_LOCAL_SERVER_URL}`
  : `${API_PROD_SERVER_URL}`;
export const CONTENT_URL_PROD = 'https://www.funbrain.com';
export const CONTENT_URL_LOCAL = 'http://funbrain-content.dev';
export const CONTENT_URL = LOCAL_CONTENT ? CONTENT_URL_LOCAL : CONTENT_URL_PROD;

export const capitalize = str => str.substr(0, 1).toUpperCase() + str.substr(1);
